"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _ReactDragListView2 = _interopRequireDefault(require("./ReactDragListView"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0, _get2.default)((0, _getPrototypeOf2.default)(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
var UNIT_PX = 'px';

// TODO: move them to styled component
var DRAG_LIND_STYLE = 'width:0;margin-left:-1px;margin-top:0;' + 'border-bottom:0 none;border-left:solid 2px #4691f3;';
var DIRECTIONS = {
  RIGHT: 2,
  LEFT: 4
};
var ReactDragColumnView = /*#__PURE__*/function (_ReactDragListView) {
  function ReactDragColumnView() {
    (0, _classCallCheck2.default)(this, ReactDragColumnView);
    return _callSuper(this, ReactDragColumnView, arguments);
  }
  (0, _inherits2.default)(ReactDragColumnView, _ReactDragListView);
  return (0, _createClass2.default)(ReactDragColumnView, [{
    key: "getDragLine",
    value: function getDragLine() {
      if (!this.dragLine) {
        _superPropGet(ReactDragColumnView, "getDragLine", this, 3)([]);
        this.dragLine.setAttribute('style', this.dragLine.getAttribute('style') + DRAG_LIND_STYLE);
      }
      return this.dragLine;
    }
  }, {
    key: "resolveAutoScroll",
    value: function resolveAutoScroll(e, target) {
      if (!this.scrollElement) {
        return;
      }
      var _this$scrollElement$g = this.scrollElement.getBoundingClientRect(),
        left = _this$scrollElement$g.left,
        width = _this$scrollElement$g.width;
      var targetWidth = target.offsetWidth;
      var pageX = e.pageX;
      var compatibleWidth = targetWidth * 2 / 3;
      this.direction = 0;
      if (pageX > left + width - compatibleWidth) {
        this.direction = DIRECTIONS.RIGHT;
      } else if (pageX < left + compatibleWidth) {
        this.direction = DIRECTIONS.LEFT;
      }
      if (this.direction) {
        if (this.scrollTimerId < 0) {
          this.scrollTimerId = setInterval(this.autoScroll, 20);
        }
      } else {
        this.stopAutoScroll();
      }
    }
  }, {
    key: "autoScroll",
    value: function autoScroll() {
      var scrollLeft = this.scrollElement.scrollLeft;
      if (this.direction === DIRECTIONS.RIGHT) {
        this.scrollElement.scrollLeft = scrollLeft + this.props.scrollSpeed;
        if (scrollLeft === this.scrollElement.scrollLeft) {
          this.stopAutoScroll();
        }
      } else if (this.direction === DIRECTIONS.LEFT) {
        this.scrollElement.scrollLeft = scrollLeft - this.props.scrollSpeed;
        if (this.scrollElement.scrollLeft <= 0) {
          this.stopAutoScroll();
        }
      } else {
        this.stopAutoScroll();
      }
    }
  }, {
    key: "fixDragLine",
    value: function fixDragLine(target) {
      var _this = this;
      var dragLine = this.getDragLine();
      if (!target || this.state.fromIndex < 0 || this.state.fromIndex === this.state.toIndex) {
        this.hideDragLine();
        return;
      }
      var getTableBody = function getTableBody() {
        var _this$props$scroll;
        if (!!((_this$props$scroll = _this.props.scroll) !== null && _this$props$scroll !== void 0 && _this$props$scroll.y)) {
          var headerTableParent = target.closest('table').parentNode;
          var bodyTableParent = headerTableParent.nextElementSibling;
          return bodyTableParent;
        }
        return target.closest('thead').nextElementSibling;
      };
      var _getTableBody$getBoun = getTableBody().getBoundingClientRect(),
        bodyHeight = _getTableBody$getBoun.height;
      var _target$getBoundingCl = target.getBoundingClientRect(),
        left = _target$getBoundingCl.left,
        top = _target$getBoundingCl.top,
        width = _target$getBoundingCl.width,
        height = _target$getBoundingCl.height;
      var lineLeft = this.state.toIndex < this.state.fromIndex ? left : left + width;
      if (this.props.enableScroll && this.scrollElement) {
        var _this$scrollElement$g2 = this.scrollElement.getBoundingClientRect(),
          scrollWidth = _this$scrollElement$g2.width,
          scrollLeft = _this$scrollElement$g2.left;
        if (lineLeft < scrollLeft - 2 || lineLeft > scrollLeft + scrollWidth + 2) {
          this.hideDragLine();
          return;
        }
      }
      dragLine.style.top = top + UNIT_PX;
      dragLine.style.height = height + bodyHeight + UNIT_PX;
      dragLine.style.left = lineLeft + UNIT_PX;
      dragLine.style.display = 'block';
    }
  }]);
}(_ReactDragListView2.default);
var _default = exports.default = ReactDragColumnView;